"use client";

import React from "react";
import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";

const AnalyticsProvider: React.FC = () => {
  return (
    <>
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_MEASUREMENT_ID!} />
      <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID!} />
    </>
  );
};

export default AnalyticsProvider;
